











import { Component, Vue } from 'vue-property-decorator';
import AccountSettingsInvoice from "@/views/Settings/AccountSettingsInvoice.vue";
import SlideIn from "@/components/basic/SlideIn.vue";

@Component({
  components: {
    AccountSettingsInvoice,
    SlideIn
  },
})
export default class OutInvAccountSettings extends Vue {
  loading=true;

  mounted(){
    this.openSlideIn();
  }

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: 'OutgoingInvoiceEdit', params: this.$router.currentRoute.params });
  }
}
